exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#qb-transaction_filter {\n  display: none !important;\n}\n.paginate_button {\n  padding: 2px !important;\n  background: #f6f7f7;\n  cursor: pointer;\n  border-radius: 5px;\n  margin: 0 1px;\n  text-decoration: none;\n}\n.paginate_button:hover {\n  padding: 2px !important;\n  background: #38b2b0 !important;\n  color: white !important;\n  cursor: pointer;\n  text-decoration: none;\n}\n", ""]);

// exports
